export enum DocumentNamePosition {
  DocumentNode,
  PartNode
}
